import React from 'react';

// 1. Workflow SVG with animation - completely new design
export const WorkflowSVG = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 240 240"
            className={className}
        >
            {/* Background with grid for workflow canvas */}
            <defs>
                <pattern id="workflowGrid" width="20" height="20" patternUnits="userSpaceOnUse">
                    <path d="M 20 0 L 0 0 0 20" fill="none" stroke="#3B82F6" strokeWidth="0.5" strokeOpacity="0.1" />
                </pattern>
                <linearGradient id="flowGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#2563EB" stopOpacity="0.1" />
                    <stop offset="100%" stopColor="#60A5FA" stopOpacity="0.2" />
                </linearGradient>
            </defs>
            <rect width="240" height="240" fill="url(#workflowGrid)" />
            <rect x="20" y="20" width="200" height="200" rx="10" fill="url(#flowGradient)" />

            {/* Workflow stages */}
            {/* Stage 1: Input */}
            <rect x="30" y="40" width="40" height="30" rx="5" fill="#3B82F6" fillOpacity="0.8" className="animate-pulse" style={{ animationDuration: "3s" }} />
            <rect x="35" y="45" width="30" height="20" rx="3" fill="#1E3A8A" fillOpacity="0.8" />
            <line x1="37" y1="55" x2="63" y2="55" stroke="#BFDBFE" strokeWidth="2" />
            <line x1="37" y1="60" x2="55" y2="60" stroke="#BFDBFE" strokeWidth="2" />

            {/* Connector 1 */}
            <path d="M70 55 L95 55 Q 105 55 105 65 L105 115 Q 105 125 115 125 L130 125"
                fill="none"
                stroke="#60A5FA"
                strokeWidth="2"
                strokeDasharray="4,2"
                className="animate-dash" />

            {/* Animated data packet 1 */}
            <circle cx="0" cy="0" r="3" fill="#93C5FD">
                <animateMotion
                    path="M70 55 L95 55 Q 105 55 105 65 L105 115 Q 105 125 115 125 L130 125"
                    dur="2s"
                    repeatCount="indefinite"
                />
            </circle>

            {/* Stage 2: Process */}
            <rect x="130" y="110" width="50" height="30" rx="5" fill="#3B82F6" fillOpacity="0.9" className="animate-pulse" style={{ animationDuration: "2.5s" }} />

            {/* Gear animation */}
            <circle cx="145" cy="125" r="8" fill="#BFDBFE" className="animate-spin" style={{ transformOrigin: "145px 125px", animationDuration: "6s" }} />
            <path d="M145 117 L145 115" stroke="#BFDBFE" strokeWidth="2" strokeLinecap="round" />
            <path d="M145 135 L145 133" stroke="#BFDBFE" strokeWidth="2" strokeLinecap="round" />
            <path d="M137 125 L135 125" stroke="#BFDBFE" strokeWidth="2" strokeLinecap="round" />
            <path d="M155 125 L153 125" stroke="#BFDBFE" strokeWidth="2" strokeLinecap="round" />
            <path d="M139 119 L137 117" stroke="#BFDBFE" strokeWidth="2" strokeLinecap="round" />
            <path d="M153 133 L151 131" stroke="#BFDBFE" strokeWidth="2" strokeLinecap="round" />
            <path d="M139 131 L137 133" stroke="#BFDBFE" strokeWidth="2" strokeLinecap="round" />
            <path d="M153 117 L151 119" stroke="#BFDBFE" strokeWidth="2" strokeLinecap="round" />
            <circle cx="145" cy="125" r="4" fill="#1E3A8A" />

            {/* Process icon */}
            <rect x="160" y="115" width="15" height="20" rx="2" fill="#BFDBFE" />
            <line x1="163" y1="120" x2="172" y2="120" stroke="#1E3A8A" strokeWidth="1.5" />
            <line x1="163" y1="125" x2="172" y2="125" stroke="#1E3A8A" strokeWidth="1.5" />
            <line x1="163" y1="130" x2="169" y2="130" stroke="#1E3A8A" strokeWidth="1.5" />

            {/* Connector 2 */}
            <path d="M180 125 L190 125 Q 200 125 200 135 L200 175 Q 200 185 190 185 L75 185"
                fill="none"
                stroke="#60A5FA"
                strokeWidth="2"
                strokeDasharray="4,2"
                className="animate-dash" />

            {/* Animated data packet 2 */}
            <circle cx="0" cy="0" r="3" fill="#93C5FD">
                <animateMotion
                    path="M180 125 L190 125 Q 200 125 200 135 L200 175 Q 200 185 190 185 L75 185"
                    dur="3s"
                    repeatCount="indefinite"
                    begin="0.5s"
                />
            </circle>

            {/* Stage 3: Output */}
            <rect x="35" y="170" width="40" height="30" rx="5" fill="#3B82F6" fillOpacity="0.8" className="animate-pulse" style={{ animationDuration: "3.5s" }} />
            <rect x="40" y="175" width="30" height="20" rx="3" fill="#1E3A8A" fillOpacity="0.8" />

            {/* Document icon */}
            <path d="M43 177 L67 177 L67 193 L43 193 Z" fill="#BFDBFE" />
            <line x1="46" y1="180" x2="64" y2="180" stroke="#1E3A8A" strokeWidth="1" />
            <line x1="46" y1="184" x2="64" y2="184" stroke="#1E3A8A" strokeWidth="1" />
            <line x1="46" y1="188" x2="58" y2="188" stroke="#1E3A8A" strokeWidth="1" />

            {/* Decision node */}
            <polygon points="90,55 110,70 90,85 70,70" fill="#60A5FA" fillOpacity="0.7" className="animate-pulse" style={{ animationDuration: "2s" }} />
            <text x="90" y="74" textAnchor="middle" fill="#FFFFFF" fontSize="15" fontWeight="bold">?</text>

            {/* Connector to alternative path */}
            <path d="M90 85 L90 145 Q 90 155 100 155 L130 155"
                fill="none"
                stroke="#60A5FA"
                strokeWidth="2"
                strokeDasharray="4,2"
                strokeOpacity="0.6"
                className="animate-dash" />

            {/* Alternative process node */}
            <rect x="130" y="145" width="20" height="20" fill="#60A5FA" fillOpacity="0.6" className="animate-pulse" style={{ animationDuration: "4s" }} />
            <line x1="135" y1="155" x2="145" y2="155" stroke="#FFFFFF" strokeWidth="2" />
            <line x1="140" y1="150" x2="140" y2="160" stroke="#FFFFFF" strokeWidth="2" />

            {/* Additional workflow connections */}
            <path d="M40 70 L40 95 Q 40 105 50 105 L60 105"
                fill="none"
                stroke="#60A5FA"
                strokeWidth="2"
                strokeDasharray="4,2"
                strokeOpacity="0.6"
                className="animate-dash" />

            <rect x="60" y="95" width="20" height="20" fill="#3B82F6" fillOpacity="0.7" className="animate-pulse" style={{ animationDuration: "2.7s" }} />
            <line x1="65" y1="105" x2="75" y2="105" stroke="#FFFFFF" strokeWidth="1.5" />
            <line x1="67" y1="102" x2="73" y2="108" stroke="#FFFFFF" strokeWidth="1.5" />
            <line x1="67" y1="108" x2="73" y2="102" stroke="#FFFFFF" strokeWidth="1.5" />
        </svg>
    );
};

// 2. Scheduling SVG with animation
export const SchedulingSVG = ({ className }) => {
    return (
        <svg
            viewBox="0 0 240 200"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            {/* Background glow */}
            <defs>
                <linearGradient id="scheduleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#F59E0B" stopOpacity="0.2" />
                    <stop offset="100%" stopColor="#FBBF24" stopOpacity="0.2" />
                </linearGradient>
            </defs>
            <rect x="10" y="10" width="220" height="180" rx="10" fill="url(#scheduleGradient)" opacity="0.5" />

            {/* Clock face */}
            <circle cx="120" cy="95" r="70" fill="none" stroke="#F59E0B" strokeWidth="4" opacity="0.7" />

            {/* Clock markings */}
            <line x1="120" y1="35" x2="120" y2="45" stroke="#F59E0B" strokeWidth="3" />
            <line x1="120" y1="145" x2="120" y2="155" stroke="#F59E0B" strokeWidth="3" />
            <line x1="60" y1="95" x2="70" y2="95" stroke="#F59E0B" strokeWidth="3" />
            <line x1="170" y1="95" x2="180" y2="95" stroke="#F59E0B" strokeWidth="3" />

            {/* Clock hands */}
            <line x1="120" y1="95" x2="120" y2="50" stroke="#F59E0B" strokeWidth="4">
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 120 95"
                    to="360 120 95"
                    dur="12s"
                    repeatCount="indefinite" />
            </line>
            <line x1="120" y1="95" x2="160" y2="95" stroke="#FBBF24" strokeWidth="4">
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 120 95"
                    to="360 120 95"
                    dur="60s"
                    repeatCount="indefinite" />
            </line>

            {/* Center dot */}
            <circle cx="120" cy="95" r="6" fill="#FFFFFF" />

            {/* Task icons around the clock */}
            <g transform="translate(60, 40)">
                <rect x="0" y="0" width="15" height="15" rx="2" fill="#FFFFFF" opacity="0.8" />
                <line x1="3" y1="5" x2="12" y2="5" stroke="#F59E0B" strokeWidth="2" />
                <line x1="3" y1="9" x2="8" y2="9" stroke="#F59E0B" strokeWidth="2" />
            </g>

            <g transform="translate(170, 50)">
                <rect x="0" y="0" width="15" height="15" rx="2" fill="#FFFFFF" opacity="0.8" />
                <line x1="3" y1="5" x2="12" y2="5" stroke="#F59E0B" strokeWidth="2" />
                <line x1="3" y1="9" x2="8" y2="9" stroke="#F59E0B" strokeWidth="2" />
            </g>

            <g transform="translate(180, 120)">
                <rect x="0" y="0" width="15" height="15" rx="2" fill="#FFFFFF" opacity="0.8" />
                <line x1="3" y1="5" x2="12" y2="5" stroke="#F59E0B" strokeWidth="2" />
                <line x1="3" y1="9" x2="8" y2="9" stroke="#F59E0B" strokeWidth="2" />
            </g>

            <g transform="translate(50, 140)">
                <rect x="0" y="0" width="15" height="15" rx="2" fill="#FFFFFF" opacity="0.8" />
                <line x1="3" y1="5" x2="12" y2="5" stroke="#F59E0B" strokeWidth="2" />
                <line x1="3" y1="9" x2="8" y2="9" stroke="#F59E0B" strokeWidth="2" />
            </g>

            {/* Animated task completion */}
            <circle cx="170" cy="57" r="5" fill="#8B5CF6" opacity="0.8">
                <animate attributeName="r" values="3;5;3" dur="2s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.3;0.8;0.3" dur="2s" repeatCount="indefinite" />
            </circle>
        </svg>
    );
};

export const MonitoringSVG = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 240 240"
            className={className}
        >
            {/* Background */}
            <defs>
                <linearGradient id="monitorGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#7E22CE" stopOpacity="0.1" />
                    <stop offset="100%" stopColor="#A855F7" stopOpacity="0.1" />
                </linearGradient>
            </defs>
            <rect x="20" y="20" width="200" height="200" rx="10" fill="url(#monitorGradient)" />

            {/* Central monitor display */}
            <rect x="40" y="40" width="160" height="90" rx="5" fill="#1E1E3F" stroke="#A855F7" strokeWidth="2" />

            {/* Monitor screen content */}
            <rect x="45" y="45" width="150" height="80" rx="2" fill="#1E1E3F" />

            {/* Line chart on screen */}
            <polyline
                points="45,95 65,85 85,105 105,75 125,90 145,65 165,80 185,60"
                fill="none"
                stroke="#A855F7"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            {/* Data points on line */}
            <circle cx="45" cy="95" r="3" fill="#C084FC" />
            <circle cx="65" cy="85" r="3" fill="#C084FC" />
            <circle cx="85" cy="105" r="3" fill="#C084FC" />
            <circle cx="105" cy="75" r="3" fill="#C084FC" />
            <circle cx="125" cy="90" r="3" fill="#C084FC" />
            <circle cx="145" cy="65" r="3" fill="#C084FC" className="animate-pulse" style={{ animationDuration: "2s" }} />
            <circle cx="165" cy="80" r="3" fill="#C084FC" />
            <circle cx="185" cy="60" r="3" fill="#C084FC" />

            {/* Status indicators */}
            <rect x="45" y="50" width="30" height="5" rx="1" fill="#A855F7" fillOpacity="0.5" />
            <rect x="45" y="60" width="20" height="5" rx="1" fill="#A855F7" fillOpacity="0.5" />
            <rect x="155" y="50" width="30" height="5" rx="1" fill="#A855F7" fillOpacity="0.5" />
            <rect x="165" y="60" width="20" height="5" rx="1" fill="#A855F7" fillOpacity="0.5" />

            {/* Pulse alert circle */}
            <circle cx="190" cy="50" r="5" fill="#EF4444">
                <animate attributeName="r" values="4;6;4" dur="2s" repeatCount="indefinite" />
                <animate attributeName="fill-opacity" values="0.6;1;0.6" dur="2s" repeatCount="indefinite" />
            </circle>

            {/* Server/System rack below monitor */}
            <rect x="80" y="150" width="80" height="60" rx="2" fill="#1E1E3F" stroke="#A855F7" strokeWidth="1.5" />

            {/* Server units */}
            <rect x="85" y="155" width="70" height="10" rx="1" fill="#2D2B55" />
            <rect x="85" y="170" width="70" height="10" rx="1" fill="#2D2B55" />
            <rect x="85" y="185" width="70" height="10" rx="1" fill="#2D2B55" />
            <rect x="85" y="200" width="70" height="5" rx="1" fill="#2D2B55" />

            {/* Server indicator lights */}
            <circle cx="90" cy="160" r="2" fill="#10B981">
                <animate attributeName="fill-opacity" values="0.5;1;0.5" dur="1.5s" repeatCount="indefinite" />
            </circle>
            <circle cx="90" cy="175" r="2" fill="#10B981">
                <animate attributeName="fill-opacity" values="0.5;1;0.5" dur="2.7s" repeatCount="indefinite" />
            </circle>
            <circle cx="90" cy="190" r="2" fill="#F59E0B">
                <animate attributeName="fill-opacity" values="0.5;1;0.5" dur="0.9s" repeatCount="indefinite" />
            </circle>

            {/* Connection line from servers to monitor */}
            <path
                d="M120 150 L120 130"
                stroke="#A855F7"
                strokeWidth="2"
                strokeDasharray="4,2"
            />

            {/* Animated data packets traveling up */}
            <circle cx="120" cy="140" r="3" fill="#C084FC">
                <animate
                    attributeName="cy"
                    values="150;130"
                    dur="1.5s"
                    repeatCount="indefinite"
                />
                <animate
                    attributeName="opacity"
                    values="0;1;0"
                    dur="1.5s"
                    repeatCount="indefinite"
                />
            </circle>

            <circle cx="120" cy="140" r="3" fill="#C084FC">
                <animate
                    attributeName="cy"
                    values="150;130"
                    dur="1.5s"
                    begin="0.5s"
                    repeatCount="indefinite"
                />
                <animate
                    attributeName="opacity"
                    values="0;1;0"
                    dur="1.5s"
                    begin="0.5s"
                    repeatCount="indefinite"
                />
            </circle>

            {/* Side monitoring devices */}
            <rect x="30" y="150" width="30" height="20" rx="2" fill="#1E1E3F" stroke="#A855F7" strokeWidth="1" />
            <rect x="180" y="150" width="30" height="20" rx="2" fill="#1E1E3F" stroke="#A855F7" strokeWidth="1" />

            {/* Side devices connections */}
            <path
                d="M60 160 L80 160"
                stroke="#A855F7"
                strokeWidth="1.5"
                strokeDasharray="3,2"
            />
            <path
                d="M160 160 L180 160"
                stroke="#A855F7"
                strokeWidth="1.5"
                strokeDasharray="3,2"
            />

            {/* Side device screens */}
            <rect x="35" y="155" width="20" height="10" rx="1" fill="#2D2B55" />
            <rect x="185" y="155" width="20" height="10" rx="1" fill="#2D2B55" />

            {/* Side device indicators */}
            <circle cx="45" cy="160" r="3" fill="#A855F7" className="animate-pulse" style={{ animationDuration: "3s" }} />
            <circle cx="195" cy="160" r="3" fill="#A855F7" className="animate-pulse" style={{ animationDuration: "3.5s" }} />
        </svg>
    );
};